import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';
import listSegment from 'assets/dashboard/listSegment.png';
import getUserSegment from 'assets/dashboard/getSetUserSegment.png';
import updateUserSegment from 'assets/dashboard/updateSegments.png';
import vipSegment from 'assets/dashboard/vip.png';
import getUserRtfs from 'assets/dashboard/getUserRtfs.png';
import platformFeatures from 'assets/dashboard/platformFeatures.png';
import featureSegments from 'assets/dashboard/featureSegments.png';
import bulkSegmentsAssignment from 'assets/dashboard/bulkSegmentsAssignment.png';

import ListSegmentDashboard from './listUserSegment';
import GetUserSegmentDashboard from './getUserSegment';
import UpdateUserSegmentDashboard from './updateUserSegment';
import updateUserSegmentToVipDashboard from './updateUserToVip';
import GetUserRtfsDashboard from './getUserRtfs';
import PlatformFeaturesDashboard from './platformFeatures';
import FeatureSegmentsDashboard from './featureSegments';
import BulkSegmentsAssignmentDashboard from './bulkSegmentsAssignment';
// eslint-disable-next-line import/extensions
import CheckUserSegmentDashboard from './checkUserSegment';

export const USER_SEGMENT_RESOURCES = {
	listSegment: 'listSegment',
	getUserSegment: 'getUserSegment',
	updateUserSegment: 'updateUserSegment',
	updateUserSegmentToVip: 'updateUserSegmentToVip',
	platformFeatures: 'platformFeatures',
	featureSegments: 'featureSegments',
	getUserRtfs: 'getUserRtfs',
	bulkSegmentsAssignment: 'bulkSegmentsAssignment',
	checkUserSegment: 'checkUserSegment'
};

export const URL = {
	[USER_SEGMENT_RESOURCES.listSegment]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.userSegment}/${USER_SEGMENT_RESOURCES.listSegment}`,
	[USER_SEGMENT_RESOURCES.getUserSegment]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.userSegment}/${USER_SEGMENT_RESOURCES.getUserSegment}`,
	[USER_SEGMENT_RESOURCES.updateUserSegment]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.userSegment}/${USER_SEGMENT_RESOURCES.updateUserSegment}`,
	[USER_SEGMENT_RESOURCES.updateUserSegmentToVip]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.userSegment}/${USER_SEGMENT_RESOURCES.updateUserSegmentToVip}`,
	[USER_SEGMENT_RESOURCES.platformFeatures]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.userSegment}/${USER_SEGMENT_RESOURCES.platformFeatures}`,
	[USER_SEGMENT_RESOURCES.featureSegments]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.userSegment}/${USER_SEGMENT_RESOURCES.featureSegments}`,
	[USER_SEGMENT_RESOURCES.getUserRtfs]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.userSegment}/${USER_SEGMENT_RESOURCES.getUserRtfs}`,
	[USER_SEGMENT_RESOURCES.bulkSegmentsAssignment]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.userSegment}/${USER_SEGMENT_RESOURCES.bulkSegmentsAssignment}`,
	[USER_SEGMENT_RESOURCES.checkUserSegment]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.userSegment}/${USER_SEGMENT_RESOURCES.checkUserSegment}`
};

export const LABEL = {
	[USER_SEGMENT_RESOURCES.listSegment]: 'Segment List',
	[USER_SEGMENT_RESOURCES.getUserSegment]: 'Get User Segment',
	[USER_SEGMENT_RESOURCES.updateUserSegment]: 'Update User Segment',
	[USER_SEGMENT_RESOURCES.updateUserSegmentToVip]: 'Update User Segment to VIP',
	[USER_SEGMENT_RESOURCES.getUserRtfs]: 'Get User RTFS',
	[USER_SEGMENT_RESOURCES.platformFeatures]: 'Platform Features',
	[USER_SEGMENT_RESOURCES.featureSegments]: 'Feature Segments',
	[USER_SEGMENT_RESOURCES.bulkSegmentsAssignment]: 'Bulk Segments Assignment',
	[USER_SEGMENT_RESOURCES.checkUserSegment]: 'Check User Segment'
};

export const COMPONENT = {
	[USER_SEGMENT_RESOURCES.listSegment]: ListSegmentDashboard,
	[USER_SEGMENT_RESOURCES.getUserSegment]: GetUserSegmentDashboard,
	[USER_SEGMENT_RESOURCES.updateUserSegment]: UpdateUserSegmentDashboard,
	[USER_SEGMENT_RESOURCES.updateUserSegmentToVip]: updateUserSegmentToVipDashboard,
	[USER_SEGMENT_RESOURCES.platformFeatures]: PlatformFeaturesDashboard,
	[USER_SEGMENT_RESOURCES.featureSegments]: FeatureSegmentsDashboard,
	[USER_SEGMENT_RESOURCES.getUserRtfs]: GetUserRtfsDashboard,
	[USER_SEGMENT_RESOURCES.bulkSegmentsAssignment]: BulkSegmentsAssignmentDashboard,
	[USER_SEGMENT_RESOURCES.checkUserSegment]: CheckUserSegmentDashboard
};

export const GET_ACTION = {
	[USER_SEGMENT_RESOURCES.listSegment]: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].getSegmentList,
	[USER_SEGMENT_RESOURCES.getUserSegment]: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].getUserDetails,
	[USER_SEGMENT_RESOURCES.updateUserSegment]: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].updateUserDetails,
	[USER_SEGMENT_RESOURCES.updateUserSegmentToVip]: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].updateUserSegmentToVip,
	[USER_SEGMENT_RESOURCES.platformFeatures]: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].platformFeatures,
	[USER_SEGMENT_RESOURCES.featureSegments]: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].featureSegments,
	[USER_SEGMENT_RESOURCES.getUserRtfs]: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].getUserRtfs,
	[USER_SEGMENT_RESOURCES.bulkSegmentsAssignment]: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].bulkSegmentAssignment,
	[USER_SEGMENT_RESOURCES.checkUserSegment]: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].listUserSegments
};

export const IMAGE_SOURCE = {
	[USER_SEGMENT_RESOURCES.listSegment]: listSegment,
	[USER_SEGMENT_RESOURCES.getUserSegment]: getUserSegment,
	[USER_SEGMENT_RESOURCES.updateUserSegment]: updateUserSegment,
	[USER_SEGMENT_RESOURCES.updateUserSegmentToVip]: vipSegment,
	[USER_SEGMENT_RESOURCES.platformFeatures]: platformFeatures,
	[USER_SEGMENT_RESOURCES.featureSegments]: featureSegments,
	[USER_SEGMENT_RESOURCES.getUserRtfs]: getUserRtfs,
	[USER_SEGMENT_RESOURCES.bulkSegmentsAssignment]: bulkSegmentsAssignment,
	[USER_SEGMENT_RESOURCES.checkUserSegment]: getUserSegment
};

export type Record = {
	[key: string]: string | number | boolean;
};

export type SelectedUserType = {
	email: string;
	uid: string;
	phone: string;
	userSegment: string;
	addToStatic: boolean;
};
